import React, { useState, useEffect } from 'react';
import './FichaTecnicaNB.css'
import { useTranslation } from 'react-i18next';
import { fetchFichaTecnica, fetchFichaTecnicaWBL } from '../utils/api';
import { URL } from '../utils/constants';
import { calcFontSize } from '../utils/common';


const FichaTecnicaNB = () => {
    const { t } = useTranslation();
    const [fichaDataNB, setFichaDataNB] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isMobileNb, setIsMobileNb] = useState(window.innerWidth <= 910);

    useEffect(() => {
      const handleResize = () => {
        setIsMobileNb(window.innerWidth <= 910);
      };
    
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const lang = localStorage.getItem('locale') || 'ca_ES'; // Default to 'es' if not found
        let locale;
        switch (lang) {
          case 'es_ES':
            locale = 'es';
            break;
          case 'ca_ES':
            locale = 'cat';
            break;
          case 'en_GB':
            locale = 'en';
            break;
          default:
            locale = 'cat';
        }
        fetchFichaTecnicaWBL(locale)
          .then(data => {
            console.log(data);
            setFichaDataNB(data);
            setLoading(false);
          })
          .catch(error => {
            setError(error);
            setLoading(false);
          });
      }, []);

      console.log('ficha tecnica NB', fichaDataNB);


      if (loading) {
        return <div aria-live="polite">Loading...</div>;
      }
    
      if (error) {
        return <div aria-live="polite">Error: {error.message}</div>;
      }

      
    const handleDownload = () => {
        window.location.href = URL?.urlDescargaWBL;
      };
    
      const onBack = () => {
        window.history.back();
      } 

      
  return (
    <div aria-labelledby="dataSheetTitle" style={{ fontSize:calcFontSize(14)}} className="parentNb">
<div className="div1nb">
<h1 tabIndex="0" style={{ fontSize:calcFontSize(16)}} aria-label={t("dataSheet.titleNB")} className='titleFichanb' >{t("dataSheet.titleNB")}</h1>
<p tabIndex="0" aria-label={t("dataSheet.descriptionWBL")} className='subTitle'>{t("dataSheet.descriptionWBL")}</p>
        {/* debera ser dinaminoc */}
</div>
<div className="div2nb">
    <p tabIndex="0" aria-label={t("dataSheet.creationDate")} className='titleFichanb'>{t("dataSheet.creationDate")}</p>
    <p className='spanBorderNb'></p>
</div>
<div className="div3nb">
    <p tabIndex="0" aria-label={fichaDataNB?.creationDate} className='dinamicTitlenb'>{fichaDataNB?.creationDate}</p>
    <p className='spanBorderNb'></p>
 </div>
<div className="div4nb" >
    <p tabIndex="0" aria-label={t("dataSheet.geographicScope")} className='titleFichanb'>{t("dataSheet.geographicScope")}</p>
    <p className='spanBorderNb'></p>
</div>
<div className="div5nb">
    <p tabIndex="0" aria-label={fichaDataNB?.geografico} className='dinamicTitlenb'>{fichaDataNB?.geografico}</p>
    <p className='spanBorderNb'></p>
</div>
<div className="div6nb" >
    <p tabIndex="0" aria-label={t("dataSheet.updateFrequency")} className='titleFichanb'>{t("dataSheet.updateFrequency")}</p>
    <p className='spanBorderNb'></p>
</div>
<div className="div7nb">
    <p tabIndex="0" aria-label={fichaDataNB?.uploadFrecuency} className='dinamicTitlenb'>{fichaDataNB?.uploadFrecuency}</p>
    <p className='spanBorderNb'></p>
</div>
<div className="div8nb">
    <p tabIndex="0" aria-label={t("dataSheet.license")} className='titleFichanb'>{t("dataSheet.license")}</p>
    <p className='spanBorderNb'></p>    
 </div>
<div className="div9nb">
    <p tabIndex="0" aria-label={fichaDataNB?.licence} className='dinamicTitlenb' style={{ fontSize: calcFontSize(10), marginBottom:"12px" }}>{fichaDataNB?.licence}</p>
    <p className='spanBorderNb'></p> 
</div>
<div className="div10nb">
<div className="div8nb">
    {/* <p className='titleFicha'>{t("dataSheet.dataSource")}</p>
    <p className='spanBorder'></p>    */} 
 </div>
</div>
<div className="div11nb">
{/* <p className='dinamicTitle'>{fichaDataNB?.formato}</p>
    <p className='spanBorder'></p> */}
</div>
<div className="div12nb"> </div>
<div className="div13nb"> </div>
<div className="div14nb">
<button aria-label={t("dataSheet.backButton")} style={{ fontSize:calcFontSize(13)}} className='buttonBackData' onClick={onBack}>{t("dataSheet.backButton")}</button>
</div>
<div className="div15nb"> 
{isMobileNb && (
  <button aria-label={t("dataSheet.downloadButton")} className='buttonDiv' onClick={handleDownload}>{t("dataSheet.downloadButton")}</button>
)}
</div>
<div className="div16nb"> </div>
<div style={{ fontSize:calcFontSize(13)}} className="div17nb">
  {!isMobileNb && (
    <button aria-label={t("dataSheet.downloadButton")} className='buttonDiv' onClick={handleDownload}>{t("dataSheet.downloadButton")}</button>
  )}
   
   </div>
</div>
  )
}

export default FichaTecnicaNB